<template>
    <div>
        <el-row :gutter="5">
            <el-col :span="10">
                <el-descriptions labelStyle="width: 120px;text-align: right;" class="margin-top" title="" :column="1" border>
                    <el-descriptions-item>
                        <template slot="label">
                            申请号
                        </template>
                        {{patentData.baseInfo.ptNo}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            申请日
                        </template>
                        {{patentData.baseInfo.applyDate}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            专利类型
                        </template>
                        {{patentData.baseInfo.ptType}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            公开号
                        </template>
                        {{patentData.baseInfo.openNo}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            公开日
                        </template>
                        {{patentData.baseInfo.openDate}}
                    </el-descriptions-item>
                    <!-- <el-descriptions-item>
                        <template slot="label">
                            专利号
                        </template>
                        {{patentData.baseInfo.pid}}
                    </el-descriptions-item> -->
                    <el-descriptions-item>
                        <template slot="label">
                            申请人
                        </template>
                        {{patentData.baseInfo.ptProposer}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            地址
                        </template>
                        {{patentData.baseInfo.address}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            发明人
                        </template>
                        {{patentData.baseInfo.ptInventor}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            国省
                        </template>
                        {{patentData.baseInfo.proCode}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            分类号
                        </template>
                        {{patentData.baseInfo.ipc}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            洛迦诺分类号
                        </template>
                        {{patentData.baseInfo.loc}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            代理机构
                        </template>
                        {{patentData.baseInfo.agencyName}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            代理人
                        </template>
                        {{patentData.baseInfo.agentName}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            新兴产业分类
                        </template>
                        {{ eicfInfo }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            产业分类关键词
                        </template>
                        {{patentData.baseInfo.patentWords}}
                    </el-descriptions-item>
                </el-descriptions>
            </el-col>
            <el-col :span="14">
                <v-normal-info-right :data="data"></v-normal-info-right>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
import vSearchCondition from '../SearchCondition.vue';
import vNormalInfoRight from './NormalInfoRight.vue';
export default {
    components: {
        vSearchCondition,
        vNormalInfoRight
    },
    props: ['data'],
    data() {
        return {
            patentData: null
        }
    },
    created() {

    },
    mounted() {
        this.patentData = this.data;
    },
    computed: {
        eicfInfo() {
            // console.log(this.patentData.detail.eicf);
            var rs = '';
            if (this.patentData.detail.eicf != null) {
                this.patentData.detail.eicf.forEach(el => {
                    rs += el.strategicEmergingIndustries + ',' + el.title + ',' + el.version + ';';
                });
            }
            return rs;
        }
    },
    methods: {

    }
}
</script>
  
<style>

</style>